// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SEARCH_IN_ALL = "Hledej v inzer\u00e1tech (nap\u0159. \"tenisky Adidas\", \"ko\u010d\u00e1rek Plze\u0148\")";
